import { MdNotificationsActive } from "react-icons/md"

import "./styles.scss"
import { Popover } from "@headlessui/react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

export const NotificationMenu = () => {
  const navigate = useNavigate()
  const { allNotifications } = useSelector((state) => state.app)

  return (
    <>
      <div className="notification-select-menu">
        <Popover>
          <Popover.Button className="notification-select-menu__button">
            <>
              <MdNotificationsActive />
              {allNotifications?.counter > 0 && (
                <div className="notification-select-menu__button-badge-alert">
                  <span>{allNotifications?.counter || 0}</span>
                </div>
              )}
            </>
          </Popover.Button>
          <Popover.Panel className="notification-select-menu__popover">
            <div className="notification-select-menu__popover-content custom-popover-content">
              {allNotifications?.notifications?.length > 0 ? (
                allNotifications?.notifications?.map((item) => {
                  return (
                    <div
                      className="notification-info-box"
                      onClick={item?.notificationLink && (() => navigate(item?.notificationLink))}>
                      {item?.notificationInfo && <strong>{item?.notificationInfo}</strong>}
                      <span title="Ver notificação">
                        {item?.notificationText || "Você tem notificações a resolver"}
                      </span>
                    </div>
                  )
                })
              ) : (
                <div>
                  <span>Não há notificações</span>
                </div>
              )}
              {}
            </div>
          </Popover.Panel>
        </Popover>
      </div>
    </>
  )
}
